<template>
    <div class="animated fadeIn">
        <div class="app flex-row align-items-center">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="6">

                        <Request
                                ref="requestPasswordRecovery"
                                method="GET"
                                :options="{ blockOnProcessing: false, showAlert: false }"
                                :onRequestSuccess="requestPasswordRecoverySuccess"
                                :onRequestError="requestPasswordRecoveryError"
                                root="/user/password-recovery">
                            <slot slot="body">
                                <b-card-group>
                                    <b-card no-body class="p-4" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.primaryBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.primaryBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.primaryTextColor', '', Core.Value.typeColor)}">
                                        <b-card-body>
                                            <b-form v-on:submit.prevent="passwordRecovery">
                                                <div>
                                                    <img class="mb-4" :width="Core.Session.Setting.getSetting('environment.ui.login.logoWidth', '200px')"
                                                         :src="Core.Session.Setting.getSetting('environment.ui.login.logo', Core.Session.Setting.getSetting('environment.ui.logoFull'))">
                                                </div>
                                                <h4>{{Core.Definition.getDefinition('Récupération du mot de passe')}}</h4>
                                                <p>
                                                    {{Core.Definition.getDefinition('Entrez le courriel associé à votre compte, un lien de récupération sera envoyé par courriel.')}}</p>
                                                <b-input-group class="mb-4">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text><i class="fa fa-envelope-o"></i>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>
                                                    <b-form-input v-on:keyup.enter="passwordRecovery" v-model="dataUser" type="text" class="form-control"
                                                                  :placeholder="Core.Definition.getDefinition('Courriel')"
                                                                  autocomplete="username email"/>
                                                </b-input-group>
                                                <Alert :alert="dataAlert"></Alert>
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-button type="button" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" @click="login" class="mr-2">
                                                            <i class="fa fa-chevron-left"></i>
                                                        </b-button>
                                                        <b-button type="button" :disabled="dataProcessing" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" @click="passwordRecovery" class="px-4">
                                                            <i  v-if="dataProcessing" class="fa fa-spin fa-spinner mr-1"></i>{{Core.Definition.getDefinition('Récupérer')}}
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-card-body>
                                    </b-card>
                                </b-card-group>
                            </slot>
                        </Request>

                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Request from '../components/Request'
    import Alert from '../components/Alert'
    import CryptoJS from 'crypto-js'
    export default {
        name: 'PasswordRecovery',
        components: {
            Request,
            Alert
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataProcessing: false,
                dataUser: '',
                dataAlert: {}
            }
        },
        methods: {
            passwordRecovery() {
                this.dataProcessing = true
                this.dataAlert.show = false
                this.$refs.requestPasswordRecovery.addArg('user', this.dataUser)
                this.$refs.requestPasswordRecovery.request()
            },
            requestPasswordRecoverySuccess(data) {
                if (data.alert!==undefined) {
                    this.dataAlert = data.alert
                }
                this.dataProcessing = false
            },
            requestPasswordRecoveryError(data) {
            },
            login() {
                this.$router.push(Core.Definition.getDefinition('/connexion'))
            }
        }
    }
</script>
